import { render, staticRenderFns } from "./metodo-avaliacao-curso-editor.vue?vue&type=template&id=1db949cc&scoped=true"
import script from "./metodo-avaliacao-curso-editor.vue?vue&type=script&lang=js"
export * from "./metodo-avaliacao-curso-editor.vue?vue&type=script&lang=js"
import style0 from "./metodo-avaliacao-curso-editor.vue?vue&type=style&index=0&id=1db949cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db949cc",
  null
  
)

export default component.exports